import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Col, Row } from 'react-bootstrap'
import '../../styles/Donation/Donation.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoneyCheckDollar, faRightLeft } from '@fortawesome/free-solid-svg-icons'
import { Fade } from 'react-awesome-reveal'
import { BrowserView, MobileView } from 'react-device-detect'
import Button from '../Utils/Button'
import copy from 'copy-to-clipboard';
// import { toast } from 'react-toastify'
// import axios from 'axios'

function Donation({ ip }) {

    const navigate = useNavigate()
    const [donationType, setDonationType] = useState(null)
    // const [isLoadingDonation, setIsLoadingDonation] = useState(false)

    // const firstnameRef = useRef(null)
    // const [firstname, setFirstname] = useState("")
    // const [firstnameError, setFirstnameError] = useState(null)
    // const lastnameRef = useRef(null)
    // const [lastname, setLastname] = useState("")
    // const [lastnameError, setLastnameError] = useState(null)
    // const addressStreetRef = useRef(null)
    // const [addressStreet, setAddressStreet] = useState("")
    // const [addressStreetError, setAddressStreetError] = useState(null)
    // const addressZipcodeRef = useRef(null)
    // const [addressZipcode, setAddressZipcode] = useState("")
    // const [addressZipcodeError, setAddressZipcodeError] = useState(null)
    // const addressCityRef = useRef(null)
    // const [addressCity, setAddressCity] = useState("")
    // const [addressCityError, setAddressCityError] = useState(null)
    // const emailRef = useRef(null)
    // const [email, setEmail] = useState("")
    // const [emailError, setEmailError] = useState(null)
    // const phoneRef = useRef(null)
    // const [phone, setPhone] = useState("")
    // const [phoneError, setPhoneError] = useState(null)
    // const donationDestinationRef = useRef(null)
    // const [donationDestination, setDonationDestination] = useState("")
    // const [donationDestinationError, setDonationDestinationError] = useState(null)
    // const donationAmountRef = useRef(null)
    // const [donationAmount, setDonationAmount] = useState("")
    // const [donationAmountError, setDonationAmountError] = useStatenull)

    useEffect(() => {

        window.scrollTo({ top: 0, behavior: 'instant' })

    }, [])

    function displayDonationContent(type) {

        var donationCheck = document.getElementById('donationCheck')
        if (document.getElementById('donationCheckMobile')) {
            donationCheck = document.getElementById('donationCheckMobile')
        }
        var donationTransfer = document.getElementById('donationTransfer')
        if (document.getElementById('donationTransferMobile')) {
            donationTransfer = document.getElementById('donationTransferMobile')
        }
        donationCheck.style.height = '0'
        donationCheck.style.padding = '0 10% 0 10%'
        donationTransfer.style.height = '0'
        donationTransfer.style.padding = '0 10% 0 10%'
        if (type === 'check' && donationType !== type) {
            setDonationType(type)
            donationCheck.style.height = 'auto'
            donationCheck.style.padding = '100px 10% 100px 10%'
        } else if (type === 'check' && donationType === type) {
            setDonationType(null)
        } else if (type === 'transfer' && donationType !== type) {
            setDonationType(type)
            donationTransfer.style.height = 'auto'
            donationTransfer.style.padding = '100px 10% 100px 10%'
        } else if (type === 'transfer' && donationType === type) {
            setDonationType(null)
        }

    }

    // function sendDonation() {

    //     setIsLoadingDonation(true)
    //     var error = []
    //     if (!firstnameRef.current.textValidation(firstname)) {
    //         error.push("Le prénom est incorrect")
    //     }
    //     if (!lastnameRef.current.textValidation(lastname)) {
    //         error.push("Le nom est incorrect")
    //     }
    //     if (!addressStreetRef.current.textValidation(addressStreet)) {
    //         error.push("Le numéro et la rue sont incorrects")
    //     }
    //     if (!addressZipcodeRef.current.textValidation(addressZipcode)) {
    //         error.push("Le code postal est incorrect")
    //     }
    //     if (!addressCityRef.current.textValidation(addressCity)) {
    //         error.push("La ville est incorrecte")
    //     }
    //     if (!emailRef.current.textValidation(email)) {
    //         error.push("L'email est incorrect")
    //     }
    //     if (!phoneRef.current.textValidation(phone)) {
    //         error.push("Le numéro de téléphone est incorrect")
    //     }
    //     if (!donationDestinationRef.current.textValidation(donationDestination)) {
    //         error.push("La destination du don est incorrecte")
    //     }
    //     if (!donationAmountRef.current.numberValidation(donationAmount)) {
    //         error.push("Le montant du don est incorrect")
    //     }
    //     if (error.length > 0) {
    //         error.map((item) => toast.error(item))
    //         setIsLoadingDonation(false)
    //     } else {
    //         const toastId = toast.loading("Envois...")
    //         axios.post(process.env.REACT_APP_API_URL + 'contact/donation', {
    //             firstname: firstname,
    //             lastname: lastname,
    //             addressStreet: addressStreet,
    //             addressZipcode: addressZipcode,
    //             addressCity: addressCity,
    //             email: email,
    //             phone: phone,
    //             donationDestination: donationDestination,
    //             donationAmount: donationAmount,
    //             ip: ip
    //         }).then((response) => {
    //             if (response.data === 'TAX_RECEIPT_CREATED') {
    //                 setFirstname("")
    //                 setFirstnameError(null)
    //                 setLastname("")
    //                 setLastnameError(null)
    //                 setAddressStreet("")
    //                 setAddressStreetError(null)
    //                 setAddressZipcode("")
    //                 setAddressZipcodeError(null)
    //                 setAddressCity("")
    //                 setAddressCityError(null)
    //                 setEmail("")
    //                 setPhone("")
    //                 setPhoneError(null)
    //                 setDonationDestination("")
    //                 setDonationDestinationError(null)
    //                 setDonationAmount("")
    //                 setDonationAmountError(null)
    //                 toast.update(toastId, { render: "Demande de reçu fiscal envoyée", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
    //             }
    //             setIsLoadingDonation(false)
    //         }).catch((error) => {
    //             if (error.response) {
    //                 console.log("error :\n" + JSON.stringify(error.response.data.message) + "\n\n")
    //                 var errorMessage = error.response.data.message
    //                 if (errorMessage === 'ERROR_PARAMS') {
    //                     errorMessage = "Erreur lors des paramètres transmis"
    //                 } else if (errorMessage === 'ERROR_CONTACT_SPAM') {
    //                     errorMessage = "Erreur, vous avez déjà envoyé une demande de reçu fiscal il y a moins de 30 minutes"
    //                 } else if (errorMessage === 'ERROR_DONATION_CREATION') {
    //                     errorMessage = "Erreur lors de la création de la demande de reçu fiscal"
    //                 }
    //                 toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
    //             }
    //             setIsLoadingDonation(false)
    //         })
    //     }

    return (

        <div className='donation'>
            <Helmet>
                <meta name="title" content="Faire une donation - Vietnamensemble" />
                <meta name="description" content="Association Vietnamensemble, faire une donation" />
                <meta property="og:title" content="Faire une donation - Vietnamensemble" />
                <meta property="og:description" content="Association Vietnamensemble, faire une donation" />
                <meta property="og:url" content="https://www.vietnamensemble.org/faire-une-donation" />
                <link rel="canonical" href="https://www.vietnamensemble.org/donation" />
            </Helmet>

            <BrowserView>
                <Fade>
                    <div className='donationTitle'>Nous soutenir</div>
                </Fade>
                <Row className='donationCardRow'>
                    <Col className='donationCard' onClick={() => displayDonationContent('check')}>
                        <Fade direction={'left'} triggerOnce={true}>
                            <FontAwesomeIcon icon={faMoneyCheckDollar} className={donationType !== 'check' ? 'donationCardIcon1' : 'donationCardIcon1Active'} />
                            <div className='donationCardText1'>Par chèque bancaire</div>
                        </Fade>
                        {donationType === 'check' ?
                            <div id='donationCheckMark'></div>
                            : null
                        }
                    </Col>
                    <Col className='donationCard' onClick={() => displayDonationContent('transfer')}>
                        <Fade direction={'right'} triggerOnce={true}>
                            <FontAwesomeIcon icon={faRightLeft} className={donationType !== 'transfer' ? 'donationCardIcon2' : 'donationCardIcon2Active'} />
                            <div className='donationCardText2'>Par virement bancaire</div>
                        </Fade>
                        {donationType === 'transfer' ?
                            <div id='donationCheckMark'></div>
                            : null
                        }
                    </Col>
                </Row>
                <div id='donationCheck'>
                    {donationType === 'check' ?
                        <Fade direction={'bottom'} duration={500}>
                            <div className='donationContentText'>Associez-vous aux projets soutenus par l’association Vietnam Ensemble.</div>
                            <div className='donationContentText'>Pour faire un don, vous pouvez nous envoyer un chèque bancaire à l’ordre de « Vietnam Ensemble » à l’adresse du siège social :</div>
                            <br /><br />
                            <div className='donationContentText'>
                                Association Vietnam Ensemble (Ve)<br />
                                5 rue Henri DUNANT<br />
                                95600 EAUBONNE
                            </div>
                        </Fade>
                        : null
                    }
                </div>
                <div id='donationTransfer'>
                    {donationType === 'transfer' ?
                        <Fade direction={'bottom'} duration={500}>
                            <div className='donationContentText'>
                                Vietnam Ensemble est une association loi 1901 reconnue d’intérêt général depuis février 2025 et vos dons versés
                                ouvrent droit à une réduction d’impôt sur le revenu de 66% du don.
                            </div>
                            <div className='donationRIB'>
                                <Button theme={'dark'} rounded={true} text={"IBAN : FR76 1027 8060 6400 0205 6840 180 (Cliquer pour copier)"} onClick={() => copy('FR76 1027 8060 6400 0205 6840 180')} />
                            </div>
                            <div className='donationContentText'>
                                Pour recevoir votre reçu fiscal, merci de nous contacter :
                                <div className='donationIBANButton'>
                                    <Button theme={'dark'} rounded={true} text={"Nous contacter"} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/contactez-nous') }} />
                                </div>
                            </div>
                            <div className='donationTransferForm'>
                                {/* <Fade direction={'left'} duration={500}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'name'}
                                                theme={'light'}
                                                ref={firstnameRef}
                                                icon={<FontAwesomeIcon icon={faUser} />}
                                                text={firstname} setText={setFirstname}
                                                textError={firstnameError} setTextError={setFirstnameError}
                                                placeholder={"Prénom"}
                                                maxLength={32}
                                                onPressEnter={() => lastnameRef.current.inputTextRef.current.focus()}
                                            />
                                        </Col>
                                        <Col>
                                            <InputText
                                                type={'name'}
                                                theme={'light'}
                                                ref={lastnameRef}
                                                text={lastname} setText={setLastname}
                                                textError={lastnameError} setTextError={setLastnameError}
                                                icon={<FontAwesomeIcon icon={faUser} />}
                                                placeholder={"Nom"}
                                                maxLength={32}
                                                onPressEnter={() => emailRef.current.inputTextRef.current.focus()}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'right'} duration={500} delay={50}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'text'}
                                                theme={'light'}
                                                ref={addressStreetRef}
                                                text={addressStreet} setText={setAddressStreet}
                                                textError={addressStreetError} setTextError={setAddressStreetError}
                                                icon={<FontAwesomeIcon icon={faLocationDot} />}
                                                placeholder={"N° et rue"}
                                                maxLength={64}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'left'} duration={500} delay={100}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'text'}
                                                theme={'light'}
                                                ref={addressZipcodeRef}
                                                text={addressZipcode} setText={setAddressZipcode}
                                                textError={addressZipcodeError} setTextError={setAddressZipcodeError}
                                                icon={<FontAwesomeIcon icon={faLocationDot} />}
                                                placeholder={"Code postal"}
                                                maxLength={5}
                                            />
                                        </Col>
                                        <Col>
                                            <InputText
                                                type={'name'}
                                                theme={'light'}
                                                ref={addressCityRef}
                                                text={addressCity} setText={setAddressCity}
                                                textError={addressCityError} setTextError={setAddressCityError}
                                                icon={<FontAwesomeIcon icon={faLocationDot} />}
                                                placeholder={"Ville"}
                                                maxLength={32}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'right'} duration={500} delay={150}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'email'}
                                                theme={'light'}
                                                ref={emailRef}
                                                text={email} setText={setEmail}
                                                textError={emailError} setTextError={setEmailError}
                                                icon={<FontAwesomeIcon icon={faEnvelope} />}
                                                placeholder={"Email"}
                                                maxLength={32}
                                            />
                                        </Col>
                                        <Col>
                                            <InputText
                                                type={'phone'}
                                                theme={'light'}
                                                ref={phoneRef}
                                                text={phone} setText={setPhone}
                                                textError={phoneError} setTextError={setPhoneError}
                                                icon={<FontAwesomeIcon icon={faPhone} />}
                                                placeholder={"Téléphone"}
                                                maxLength={10}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'left'} duration={500} delay={200}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'text'}
                                                theme={'light'}
                                                ref={donationDestinationRef}
                                                text={donationDestination} setText={setDonationDestination}
                                                textError={donationDestinationError} setTextError={setDonationDestinationError}
                                                icon={<FontAwesomeIcon icon={faUsers} />}
                                                placeholder={"Destination du don"}
                                                maxLength={32}
                                            />
                                        </Col>
                                        <Col>
                                            <InputNumber
                                                type={'text'}
                                                theme={'light'}
                                                ref={donationAmountRef}
                                                number={donationAmount} setNumber={setDonationAmount}
                                                numberError={donationAmountError} setNumberError={setDonationAmountError}
                                                icon={<FontAwesomeIcon icon={faMoneyCheckDollar} />}
                                                placeholder={"Montant du don"}
                                                maxLength={32}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Row>
                                    <Col>
                                        {!isLoadingDonation ?
                                            <Fade direction={'up'} delay={200} duration={500}>
                                                <div className='donationButtonContainer'>
                                                    <Button theme={'light'} rounded={true} icon={<FontAwesomeIcon icon={faPaperPlane} className='buttonIcon' />} text={"Envoyer"} onClick={() => sendDonation()} />
                                                </div>
                                            </Fade>
                                            :
                                            <Fade duration={500}>
                                                <br />
                                                <RotatingLines
                                                    strokeColor={"#5b7c18"}
                                                    strokeWidth={"5"}
                                                    animationDuration={"1"}
                                                    width={"40"}
                                                    visible={true}
                                                />
                                            </Fade>
                                        }
                                    </Col>
                                </Row> */}
                            </div>
                        </Fade>
                        : null
                    }
                </div>
            </BrowserView>

            <MobileView>
                <Fade>
                    <div className='donationTitle'>Nous soutenir</div>
                </Fade>
                <div className='donationCard' onClick={() => displayDonationContent('check')}>
                    <Fade direction={'left'}>
                        <FontAwesomeIcon icon={faMoneyCheckDollar} className={donationType !== 'check' ? 'donationCardIcon1' : 'donationCardIcon1Active'} />
                        <div className='donationCardText1'>Par chèque bancaire</div>
                    </Fade>
                    {donationType === 'check' ?
                        <div id='donationCheckMark'></div>
                        : null
                    }
                    <div id='donationCheckMobile'>
                        {donationType === 'check' ?
                            <Fade direction={'bottom'} duration={500}>
                                <div className='donationContentText'>Associez-vous aux projets soutenus par l’association Vietnam Ensemble.</div>
                                <div className='donationContentText'>Pour faire un don, vous pouvez nous envoyer un chèque bancaire à l’ordre de « Vietnam Ensemble » à l’adresse du siège social :</div>
                                <br /><br />
                                <div className='donationContentText'>
                                    Association Vietnam Ensemble (Ve)<br />
                                    5 rue Henri DUNANT<br />
                                    95600 EAUBONNE
                                </div>
                            </Fade>
                            : null
                        }
                    </div>
                </div>
                <div className='donationCardRow'>
                    <div className='donationCard' onClick={() => displayDonationContent('transfer')}>
                        <Fade direction={'right'}>
                            <FontAwesomeIcon icon={faRightLeft} className={donationType !== 'transfer' ? 'donationCardIcon2' : 'donationCardIcon2Active'} />
                            <div className='donationCardText2'>Par virement bancaire</div>
                        </Fade>
                        {donationType === 'transfer' ?
                            <div id='donationCheckMark'></div>
                            : null
                        }
                    </div>
                </div>
                <div id='donationTransferMobile'>
                    {donationType === 'transfer' ?
                        <Fade direction={'bottom'} duration={500}>
                            <div className='donationContentText'>
                                Vietnam Ensemble est une association loi 1901 reconnue d’intérêt général depuis février 2025 et vos dons versés
                                ouvrent droit à une réduction d’impôt sur le revenu de 66% du don.
                            </div>
                            <div className='donationIBANButtonMobile'>
                                <Button theme={'dark'} rounded={true} text={<>IBAN :<br />FR76 1027 8060 6400 0205 6840 180<br />(Cliquer pour copier)</>} onClick={() => copy('FR76 1027 8060 6400 0205 6840 180')} />
                            </div>
                            <div className='donationContentText'>
                                Pour recevoir votre reçu fiscal, merci de nous contacter :
                                <div className='donationContactButtonMobile'>
                                    <Button theme={'dark'} rounded={true} text={"Nous contacter"} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate('/contactez-nous') }} />
                                </div>
                            </div>
                            <div className='aboutPeopleTextButtonMobile'>
                                {/* <Fade direction={'left'} duration={500}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'name'}
                                                theme={'light'}
                                                ref={firstnameRef}
                                                icon={<FontAwesomeIcon icon={faUser} />}
                                                text={firstname} setText={setFirstname}
                                                textError={firstnameError} setTextError={setFirstnameError}
                                                placeholder={"Prénom"}
                                                maxLength={32}
                                                onPressEnter={() => lastnameRef.current.inputTextRef.current.focus()}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'right'} duration={500}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'name'}
                                                theme={'light'}
                                                ref={lastnameRef}
                                                text={lastname} setText={setLastname}
                                                textError={lastnameError} setTextError={setLastnameError}
                                                icon={<FontAwesomeIcon icon={faUser} />}
                                                placeholder={"Nom"}
                                                maxLength={32}
                                                onPressEnter={() => emailRef.current.inputTextRef.current.focus()}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'left'} duration={500} delay={50}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'text'}
                                                theme={'light'}
                                                ref={addressStreetRef}
                                                text={addressStreet} setText={setAddressStreet}
                                                textError={addressStreetError} setTextError={setAddressStreetError}
                                                icon={<FontAwesomeIcon icon={faLocationDot} />}
                                                placeholder={"N° et rue"}
                                                maxLength={64}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'right'} duration={500} delay={100}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'text'}
                                                theme={'light'}
                                                ref={addressZipcodeRef}
                                                text={addressZipcode} setText={setAddressZipcode}
                                                textError={addressZipcodeError} setTextError={setAddressZipcodeError}
                                                icon={<FontAwesomeIcon icon={faLocationDot} />}
                                                placeholder={"Code postal"}
                                                maxLength={5}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'left'} duration={500}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'name'}
                                                theme={'light'}
                                                ref={addressCityRef}
                                                text={addressCity} setText={setAddressCity}
                                                textError={addressCityError} setTextError={setAddressCityError}
                                                icon={<FontAwesomeIcon icon={faLocationDot} />}
                                                placeholder={"Ville"}
                                                maxLength={32}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'right'} duration={500} delay={150}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'email'}
                                                theme={'light'}
                                                ref={emailRef}
                                                text={email} setText={setEmail}
                                                textError={emailError} setTextError={setEmailError}
                                                icon={<FontAwesomeIcon icon={faEnvelope} />}
                                                placeholder={"Email"}
                                                maxLength={32}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'left'} duration={500} delay={100}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'phone'}
                                                theme={'light'}
                                                ref={phoneRef}
                                                text={phone} setText={setPhone}
                                                textError={phoneError} setTextError={setPhoneError}
                                                icon={<FontAwesomeIcon icon={faPhone} />}
                                                placeholder={"Téléphone"}
                                                maxLength={10}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'right'} duration={500} delay={200}>
                                    <Row>
                                        <Col>
                                            <InputText
                                                type={'text'}
                                                theme={'light'}
                                                ref={donationDestinationRef}
                                                text={donationDestination} setText={setDonationDestination}
                                                textError={donationDestinationError} setTextError={setDonationDestinationError}
                                                icon={<FontAwesomeIcon icon={faUsers} />}
                                                placeholder={"Destination du don"}
                                                maxLength={32}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Fade direction={'left'} duration={500} delay={100}>
                                    <Row>
                                        <Col>
                                            <InputNumber
                                                type={'text'}
                                                theme={'light'}
                                                ref={donationAmountRef}
                                                number={donationAmount} setNumber={setDonationAmount}
                                                numberError={donationAmountError} setNumberError={setDonationAmountError}
                                                icon={<FontAwesomeIcon icon={faMoneyCheckDollar} />}
                                                placeholder={"Montant du don"}
                                                maxLength={32}
                                            />
                                        </Col>
                                    </Row>
                                </Fade>
                                <Row>
                                    <Col>
                                        {!isLoadingDonation ?
                                            <Fade direction={'up'} delay={200} duration={500}>
                                                <div className='donationButtonContainer'>
                                                    <Button theme={'light'} rounded={true} icon={<FontAwesomeIcon icon={faPaperPlane} className='buttonIcon' />} text={"Envoyer"} onClick={() => sendDonation()} />
                                                </div>
                                            </Fade>
                                            :
                                            <Fade duration={500}>
                                                <br />
                                                <RotatingLines
                                                    strokeColor={"#5b7c18"}
                                                    strokeWidth={"5"}
                                                    animationDuration={"1"}
                                                    width={"40"}
                                                    visible={true}
                                                />
                                            </Fade>
                                        }
                                    </Col>
                                </Row> */}
                            </div>
                        </Fade>
                        : null
                    }
                </div>
            </MobileView>
        </div>

    )

}

export default Donation